export type CategoryKey = "currency" | "interest" | "index";

export interface CurrencySeriesInfo {
  id: string;
  iso: string;
}

export interface TranslatedSeriesInfo {
  id: string;
  translationKey: string;
}

export type SeriesInfo = CurrencySeriesInfo | TranslatedSeriesInfo;

export function isCurrencySeries(series: SeriesInfo): series is CurrencySeriesInfo {
  return "iso" in series;
}

export interface CatalogCategory {
  key: CategoryKey;
  series: SeriesInfo[];
}

export interface CatalogResponse {
  categories: CatalogCategory[];
}

export type Unit = "sek_per_unit" | "percent" | "index_points";

export interface ObservationPoint {
  date: string;
  value: number;
}

export interface ObservationsResponse {
  seriesId: string;
  category: CategoryKey;
  unit: Unit;
  from: string;
  to: string;
  data: ObservationPoint[];
  available: boolean;
}

export interface ApiError {
  error: string;
}

/** Category + series + date range, the entirety of what is persisted to the URL query string. */
export interface AppState {
  category: CategoryKey;
  series: string;
  from: string;
  to: string;
}
